<template>
    <div class="template-previewer newStyle">
        <div class="row">
            <h2>{{ $t('vform.templatePreviewer')}}</h2>
        </div>
        <div class="row mb-3">
            <text-input
                ref="textinput"
                :id="'searchQuery'"
                type="text"
                :placeholder="$t('typeToSelect')"
                @typingAlert="setSearchQuery"
            />
        </div>
        <div class="template-previewer-container pt-4 pb-4 row col-12">
            <div 
                v-if="filteredTemplates.length > 0"
                v-for="template in filteredTemplates" 
                :key="template.key"
                @click="switchToTemplate(template)"
                :class="[
                    'template-previewer-item d-flex justify-content-between flex-column mr-2 mb-2 p-2',
                    selectedTemplateId === template.key ? 'selected' : '']"
            >
              <div class="icons d-flex">
                  <div class="mr-2" @click.stop="$emit('deleteTemplate', template.key)">
                    <icon type="trash" size="1.5"/>
                  </div>
                <div @click.stop="$emit('editTemplate', template.key)">
                    <icon type="pencil-alt" size="1.5"/>
                  </div>
              </div>
                <component
                    :key="forceReRenderKey"
                    :class="['template-previewer-component no-hover no-pointer', 'mb-1']"
                    :is="getComponentName(template.data.formElementType)" 
                    :template-mode="true"
                    :config="template.data"
                    lang="Unknown"
                    :state="{}"
                    :template="template"></component>
              <div class="template-name">
                {{ template.data.templateName }}
              </div>

            </div>

            <div v-if="filteredTemplates.length === 0">
                {{ $t('vform.noTemplatesFound') }}
            </div>
        </div>
    </div>
</template>

<script>
import {getComponentName} from "@/components/vForm/utils";
import TEXTDISPLAY from "@/components/vForm/viewer/TEXTDISPLAY.vue";
import BUTTON_ITEM from "@/components/vForm/viewer/BUTTON_ITEM.vue";
import HEADLINE from "@/components/vForm/viewer/HEADLINE.vue";
import RADIOBUTTONS from "@/components/vForm/viewer/RADIOBUTTONS.vue";
import CHECKBOXES from "@/components/vForm/viewer/CHECKBOXES.vue";
import LOGIN from "@/components/vForm/viewer/LOGIN.vue";
import LOGOUT from "@/components/vForm/viewer/LOGOUT.vue";
import Icon from "@/components/Icon.vue";
import TextInput from "../forms/TextInput";

export default {
    name: 'TemplatePreviewer',
    components: {
        TEXTDISPLAY,
        BUTTON_ITEM,
        HEADLINE,
        RADIOBUTTONS,
        CHECKBOXES,
        LOGIN,
        LOGOUT,
        Icon,
        TextInput,
    },
    data() {
        return {
            forceReRenderKey: 0,
            searchQuery: '',
        }
    },
    computed: {
        filteredTemplates() {
            if(this.searchQuery === '') {
                return this.compatibleTemplates;
            }

            return this.compatibleTemplates.filter(template => {
                return template.data.templateName.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        }
    },
    props: {
        compatibleTemplates: {
            type: Array,
            required: true,
        },
        selectedTemplateId: {
            type: String,
            required: true,
        }
    },
    methods: {
        getComponentName,
        switchToTemplate(template) {
            this.$emit('switchToTemplate', template.key);
        },
        setSearchQuery(input) {
            this.searchQuery = input.value;
        }
    }
}
</script>

<style lang="scss">
.template-previewer-item {
  width: 32%;
  border-radius: 5px;
  height: 100%;
  border: 1px solid var(--vform-editor-layout-primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.6;
  position: relative;
  &.selected, &:hover {
    opacity: 1;
    border: 1px solid rgba(0,0,0,0.5);
    background-color: var(--vform-editor-ui-quinary-color);
  }
  .vform-header h1.with-bg,
  .vform-header h2.with-bg,
  .vform-header h3.with-bg {
    width: auto;
    margin-left: 0;
  }
}
.template-previewer-container {
    max-height: 60vh;
    overflow: auto;
}
.icons {
  position: absolute;
  bottom: 5px;
  right: 15px;
  transition: all 300ms ease;
  .icon {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
}
.template-name {
  font-size: 1.1em;
  margin-top:15px;
}
</style>